import { render, staticRenderFns } from "./ClientSettingCreate.vue?vue&type=template&id=3bfbd475&scoped=true"
import script from "./ClientSettingCreate.vue?vue&type=script&lang=js"
export * from "./ClientSettingCreate.vue?vue&type=script&lang=js"
import style0 from "./ClientSettingCreate.vue?vue&type=style&index=0&id=3bfbd475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbd475",
  null
  
)

export default component.exports